import {useEffect, useRef} from 'react';
import {API_URL, INTERCOM_SPACE_ID} from "./settings/local_settings";
import {APIClient} from "./utils/APIClient";
import {LocalStorage} from "./utils/LocalStorage";
import Intercom from '@intercom/messenger-js-sdk';

export const IntercomScript = () => {
    const trackedUserIdRef = useRef(null);

    useEffect(() => {
        const handleUserSession = () => {
            if (!INTERCOM_SPACE_ID) {
                return;
            }

            const loggedUserIdStr = LocalStorage.fetchUserId();
            const loggedUserId = loggedUserIdStr ? parseInt(loggedUserIdStr, 10) : null;

            if (loggedUserId && loggedUserId === trackedUserIdRef.current) {
                return;
            }

            if (loggedUserId) {
                new APIClient(API_URL + 'get-logged-user-data/').call('GET').then((data) => {
                    if (data && data.status === 'OK') {
                        trackedUserIdRef.current = data.id;
                        Intercom({
                            app_id: INTERCOM_SPACE_ID,
                            email: data.email,
                            user_id: data.id,
                            name: data.name,
                            user_hash: data.intercom_user_hash,
                            company: data.intercom_company_company_id ? {
                                company_id: data.intercom_company_company_id,
                                name: data.agency_name
                            } : undefined
                        });
                    }
                });
            } else {
                if (trackedUserIdRef.current !== null) {
                    trackedUserIdRef.current = null;
                    Intercom('shutdown');
                    Intercom({
                        app_id: INTERCOM_SPACE_ID
                    });
                }
            }
        };

        handleUserSession();

        window.addEventListener('storage', handleUserSession);

        return () => {
            window.removeEventListener('storage', handleUserSession);
        };
    }, []);

    return null;
};
